"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgricultureCal = void 0;
const calculator_1 = require("../calculator");
var convert = require('convert-units');
class AgricultureCal {
    static calculate(req) {
        const constants = req.agricultureConstants;
        const unitParts = constants.emissionFactorUnit.split('/');
        if (unitParts.length != 3) {
            throw Error("Invalid emission factor unit " + constants.emissionFactorUnit);
        }
        const landArea = convert(req.landArea).from(req.landAreaUnit).to(unitParts[1]);
        const duration = convert(req.duration).from(req.durationUnit).to(unitParts[2]);
        return Number((constants.emissionFactor * landArea * duration).toFixed(calculator_1.PRECISION));
    }
}
exports.AgricultureCal = AgricultureCal;
